import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const AccordionItem = ({ title, defaultOpen = false, testid, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-b border-[#e6ddcd]">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid={testid}
        className="w-full flex items-center justify-between py-5 text-left group">
        <span className="font-display text-xl sm:text-2xl text-[#1a1a1a]">{title}</span>
        <ChevronDown size={20} className={`text-[#a8823c] transition-transform duration-300 ${open ? 'rotate-180' : ''}`} />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${open ? 'max-h-[3000px] opacity-100 pb-6' : 'max-h-0 opacity-0'}`}>
        <div className="font-body text-sm text-[#4a463d] leading-relaxed space-y-3 max-w-3xl">
          {children}
        </div>
      </div>
    </div>
  );
};

const ProductPolicies = () => (
  <section className="bg-[#f7f3ec] border-t border-[#e6ddcd]">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-12">
      <AccordionItem title="Return & Refund Policy" defaultOpen testid="policy-returns">
        <ul className="space-y-3 list-none">
          <li className="flex gap-2"><span className="text-[#c6a15b]">•</span> We gladly facilitate exchanges and returns of unused items within 30 days from the date you've received all your items.</li>
          <li className="flex gap-2"><span className="text-[#c6a15b]">•</span> Items must be in their original condition, unused or damaged, including original packaging. If not, the customer is responsible for all incurred fees and no refund will be issued.</li>
          <li className="flex gap-2"><span className="text-[#c6a15b]">•</span> If the Item has a manufacturing defect or is damaged during shipping, we will cover the return shipping costs. Otherwise, return shipping costs will be the responsibility of the customer.</li>
        </ul>
      </AccordionItem>

      <AccordionItem title="Shipping & Handling" testid="policy-shipping">
        <div>
          <p className="font-medium text-[#1a1a1a] mt-1">Processing Time</p>
          <p>Some of our wigs' processing time is about 1-2 weeks. Processing time of specific items please refer to the custom time on the product page.</p>
        </div>
        <div>
          <p className="font-medium text-[#1a1a1a]">Expedited Shipping</p>
          <p>We usually ship by DHL, FedEx with expedited shipping depending on your location; shipping time is about 3 - 7 business days. Some EU countries ship by GES, DPEX-Royal which takes about 7-10 business days.</p>
          <p>If you need to specify the shipping carrier, pls leave a comment or contact customer service to do.</p>
        </div>
        <div>
          <p className="font-medium text-[#1a1a1a]">PO. Box & Military Base</p>
          <p>PO. Boxes, Military addresses (APO, FPO) cannot be delivered. Please offer a physical address for your order.</p>
        </div>
        <div>
          <p className="font-medium text-[#1a1a1a]">Customs &amp; Taxes</p>
          <p>Orders shipped may be subject to duties and taxes that are levied when your parcel arrives in your country. Orders will be declared as “Synthetic Hair” or “Sample” with a very lower value to help avoid taxes. Orders shipped to countries out of the United States may have taxes or duties with a random inspection. If you have any questions, please contact our customer service. Please do not directly reject or return. Any charges incurred for rejection or return shall be by customers.</p>
          <p><span className="font-medium">Nikki's Next Level Hair &amp; Beauty</span> is NOT responsible for any duties and taxes. Please contact the local customs office on your side for more information regarding customs policies.</p>
        </div>
        <div>
          <p className="font-medium text-[#1a1a1a]">Sign for Delivery</p>
          <p>It is strongly recommended for you Sign For Delivery. We ship to the correct address you left for your order but we won't be responsible for the loss caused by your authorization to leave the parcel in front of the door, courtyard or any place else.</p>
          <p>Please contact us WITHIN ONE WEEK since the package shows delivered if you didn't receive it, the shipping company does not accept investigation requests for packages delivered over one week.</p>
          <p>Customers are responsible for the <span className="font-medium">timely collection of shipments.</span> Once a package has been dispatched to the shipping carrier at the correct address, any delays, returns, or losses due to non-collection or failed delivery attempts are the responsibility of the recipient. In these cases, we are unable to issue a refund or replacement.</p>
        </div>
        <div>
          <p className="font-medium text-[#1a1a1a]">What is item processing time?</p>
          <p>After your order has been received, every item will undergo strict quality control in order to ensure the product's quality. Please note that different items are subject to different processing times.</p>
        </div>
        <div>
          <p className="font-medium text-[#1a1a1a]">Please Note</p>
          <p>Total Delivery Time = Processing Time + Shipping Time</p>
          <p>Annual Chinese Public Holidays: Chinese Lunar New Year (usually in February), Labor Day (1st May every year), Chinese National Day (1st October every year). Please note that all delivery times will be affected during these times of the year as the service from all our suppliers and logistics operators will be disrupted. There is often a delay of 3-4 days and sometimes even longer. We sincerely apologize for any delays caused during these periods and kindly ask our customers to be patient.</p>
        </div>
      </AccordionItem>
    </div>
  </section>
);

export default ProductPolicies;
